/**
 * 判断是否是VooV环境
 */
export const IS_I18N = process.env.IS_I18N === 'true';
